<template lang="pug">
.my-4.rounded.shadow.bg-white
  .p-4.border-b.border-gray-200.flex(v-if="hasHeaderSlot")
    slot(name="header")
  slot
</template>

<script>
export default {
  data() {
    return {};
  },
  computed: {
    hasHeaderSlot() {
      return !!this.$slots.header;
    },
  },
};
</script>
